import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { usePortalActiveClinic } from '@/lib/portalActiveClinic';

export type PortalShareableLabReport = {
  id: string;
  clinic_id: string;
  kind: string;
  received_at: string | null;
  results_datetime: string | null;
  report_status_code: string | null;
  result_status_code: string | null;
  is_copy: boolean;
  sender_name: string | null;
};

export function usePortalShareableLabReports() {
  const { activeClinicId, isLoading: clinicsLoading } = usePortalActiveClinic();

  const query = useQuery({
    queryKey: ['portal', 'lab-reports', activeClinicId],
    enabled: Boolean(activeClinicId),
    queryFn: async (): Promise<PortalShareableLabReport[]> => {
      if (!activeClinicId) return [];
      const { data, error } = await supabase.rpc('portal_list_shareable_lab_reports', {
        p_clinic_id: activeClinicId,
      });
      if (error) throw error;
      return (Array.isArray(data) ? data : []) as PortalShareableLabReport[];
    },
    staleTime: 15_000,
  });

  return {
    ...query,
    isLoading: clinicsLoading || query.isLoading,
  };
}
